const topics = [
  { label: '恋爱', hot: true, count: '2.3w' },
  { label: '奇幻', hot: true, count: '1.8w' },
  { label: '逆袭', hot: true, count: '1.6w' },
  { label: '穿越', hot: false, count: '1.4w' },
  { label: '悬疑', hot: true, count: '1.2w' },
  { label: '热血', hot: false, count: '9.8k' },
  { label: '搞笑', hot: false, count: '8.5k' },
  { label: '都市', hot: false, count: '7.6k' },
  { label: '校园', hot: false, count: '6.3k' },
  { label: '古风', hot: true, count: '5.9k' },
  { label: '复仇', hot: false, count: '5.1k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              探索当下最受欢迎的漫画题材，找到属于你的阅读口味
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((t, i) => (
              <div
                key={i}
                className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
              >
                {t.hot && (
                  <span className="flex items-center">
                    <i className="ri-fire-line text-accent-500 text-sm"></i>
                  </span>
                )}
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                  {t.label}
                </span>
                <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full">
                  {t.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}